import { BaseAuthMembership } from './types';
import { getUserSelectedTeam } from '../../utils/user';

export function getCurrentMembership(
  memberships: BaseAuthMembership[],
  routeQueryTeamName: string | undefined,
): BaseAuthMembership | null {
  if (memberships.length > 0) {
    const savedTeamName = routeQueryTeamName || getUserSelectedTeam();

    const foundMembership = memberships.find((item) => item.team?.name === savedTeamName);

    return foundMembership || memberships[0];
  }

  return null;
}

export function sortMemberships(mems: BaseAuthMembership[]) {
  mems.sort((a, b) => {
    const m = a.team?.name,
      n = b.team?.name;
    if (!m) return n ? -1 : 0;
    if (!n) return 1;

    return m > n ? 1 : -1;
  });

  return mems;
}

/**
 * mergeMemberships returns mems with mem replacing an existing
 * Membership of the same name, or inserted at the correct position.
 */
export function mergeMemberships(
  mems: BaseAuthMembership[],
  mem: BaseAuthMembership,
): BaseAuthMembership[] {
  if (!mem.team?.name) {
    return mems;
  }
  if (!mems?.length) {
    return [mem];
  }

  const memIndexToUpdate = mems.findIndex((item) => item.team?.name === mem.team?.name);

  if (memIndexToUpdate === -1) {
    mems.push(mem);
  } else {
    mems[memIndexToUpdate] = mem;
  }

  return mems;
}

export function getSamlEndpoint(headers: Headers | undefined) {
  return headers?.get('X-Cq-Saml-Login');
}

export function getMfaRequired(headers: Headers | undefined): boolean | undefined {
  const headerValue = headers?.get('X-Cq-Mfa-Required');

  return headerValue === 'true';
}

export function getMfaConfigured(headers: Headers | undefined): boolean | undefined {
  const headerValue = headers?.get('X-Cq-Mfa-Configured');

  return headerValue === 'true';
}
